import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import { environment } from 'src/environments/environment';

@Injectable()
export class SidebarService {
	constructor(private http: HttpClient) {}

	loadSideBar() {
		return this.http.get<any>(
			`${environment.url.cohort}/student/${
				firebase.auth().currentUser?.email
			}/cohorts/v2`,
		);
	}
}
